import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2fa66790 = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _03607a2a = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _69e21706 = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _02436c24 = () => interopDefault(import('../../../pages/comparison/index.vue' /* webpackChunkName: "pages/comparison/index" */))
const _c309a310 = () => interopDefault(import('../../../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _0473d1ba = () => interopDefault(import('../../../pages/integrations/index.vue' /* webpackChunkName: "pages/integrations/index" */))
const _0e2b31c4 = () => interopDefault(import('../../../pages/pricing.vue' /* webpackChunkName: "pages/pricing" */))
const _298c126f = () => interopDefault(import('../../../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _4322d7c7 = () => interopDefault(import('../../../pages/product.vue' /* webpackChunkName: "pages/product" */))
const _6d0422d8 = () => interopDefault(import('../../../pages/roadmap.vue' /* webpackChunkName: "pages/roadmap" */))
const _146da480 = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _5916702c = () => interopDefault(import('../../../pages/support/index.vue' /* webpackChunkName: "pages/support/index" */))
const _69145ed4 = () => interopDefault(import('../../../pages/templates/index.vue' /* webpackChunkName: "pages/templates/index" */))
const _a5438f42 = () => interopDefault(import('../../../pages/terms.vue' /* webpackChunkName: "pages/terms" */))
const _51035a18 = () => interopDefault(import('../../../pages/use-cases/index.vue' /* webpackChunkName: "pages/use-cases/index" */))
const _69b176f8 = () => interopDefault(import('../../../pages/blog/topics/_slug.vue' /* webpackChunkName: "pages/blog/topics/_slug" */))
const _49fe2c77 = () => interopDefault(import('../../../pages/support/topics/_slug.vue' /* webpackChunkName: "pages/support/topics/_slug" */))
const _6d4f5996 = () => interopDefault(import('../../../pages/blog/_slug.vue' /* webpackChunkName: "pages/blog/_slug" */))
const _02bd3072 = () => interopDefault(import('../../../pages/integrations/_slug.vue' /* webpackChunkName: "pages/integrations/_slug" */))
const _5c83b2bc = () => interopDefault(import('../../../pages/support/_slug.vue' /* webpackChunkName: "pages/support/_slug" */))
const _4f4cb8d0 = () => interopDefault(import('../../../pages/use-cases/_slug.vue' /* webpackChunkName: "pages/use-cases/_slug" */))
const _008ccadc = () => interopDefault(import('../../../pages/comparison/_slug.vue' /* webpackChunkName: "pages/comparison/_slug" */))
const _675dbd8c = () => interopDefault(import('../../../pages/templates/_slug.vue' /* webpackChunkName: "pages/templates/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _2fa66790,
    name: "404___en"
  }, {
    path: "/bg",
    component: _03607a2a,
    name: "index___bg"
  }, {
    path: "/blog",
    component: _69e21706,
    name: "blog___en"
  }, {
    path: "/comparison",
    component: _02436c24,
    name: "comparison___en"
  }, {
    path: "/contact",
    component: _c309a310,
    name: "contact___en"
  }, {
    path: "/es",
    component: _03607a2a,
    name: "index___es"
  }, {
    path: "/integrations",
    component: _0473d1ba,
    name: "integrations___en"
  }, {
    path: "/pricing",
    component: _0e2b31c4,
    name: "pricing___en"
  }, {
    path: "/privacy-policy",
    component: _298c126f,
    name: "privacy-policy___en"
  }, {
    path: "/product",
    component: _4322d7c7,
    name: "product___en"
  }, {
    path: "/roadmap",
    component: _6d0422d8,
    name: "roadmap___en"
  }, {
    path: "/search",
    component: _146da480,
    name: "search___en"
  }, {
    path: "/support",
    component: _5916702c,
    name: "support___en"
  }, {
    path: "/templates",
    component: _69145ed4,
    name: "templates___en"
  }, {
    path: "/terms",
    component: _a5438f42,
    name: "terms___en"
  }, {
    path: "/use-cases",
    component: _51035a18,
    name: "use-cases___en"
  }, {
    path: "/bg/404",
    component: _2fa66790,
    name: "404___bg"
  }, {
    path: "/bg/blog",
    component: _69e21706,
    name: "blog___bg"
  }, {
    path: "/bg/comparison",
    component: _02436c24,
    name: "comparison___bg"
  }, {
    path: "/bg/contact",
    component: _c309a310,
    name: "contact___bg"
  }, {
    path: "/bg/integrations",
    component: _0473d1ba,
    name: "integrations___bg"
  }, {
    path: "/bg/pricing",
    component: _0e2b31c4,
    name: "pricing___bg"
  }, {
    path: "/bg/privacy-policy",
    component: _298c126f,
    name: "privacy-policy___bg"
  }, {
    path: "/bg/product",
    component: _4322d7c7,
    name: "product___bg"
  }, {
    path: "/bg/roadmap",
    component: _6d0422d8,
    name: "roadmap___bg"
  }, {
    path: "/bg/search",
    component: _146da480,
    name: "search___bg"
  }, {
    path: "/bg/support",
    component: _5916702c,
    name: "support___bg"
  }, {
    path: "/bg/templates",
    component: _69145ed4,
    name: "templates___bg"
  }, {
    path: "/bg/terms",
    component: _a5438f42,
    name: "terms___bg"
  }, {
    path: "/bg/use-cases",
    component: _51035a18,
    name: "use-cases___bg"
  }, {
    path: "/es/404",
    component: _2fa66790,
    name: "404___es"
  }, {
    path: "/es/blog",
    component: _69e21706,
    name: "blog___es"
  }, {
    path: "/es/comparison",
    component: _02436c24,
    name: "comparison___es"
  }, {
    path: "/es/contact",
    component: _c309a310,
    name: "contact___es"
  }, {
    path: "/es/integrations",
    component: _0473d1ba,
    name: "integrations___es"
  }, {
    path: "/es/pricing",
    component: _0e2b31c4,
    name: "pricing___es"
  }, {
    path: "/es/privacy-policy",
    component: _298c126f,
    name: "privacy-policy___es"
  }, {
    path: "/es/product",
    component: _4322d7c7,
    name: "product___es"
  }, {
    path: "/es/roadmap",
    component: _6d0422d8,
    name: "roadmap___es"
  }, {
    path: "/es/search",
    component: _146da480,
    name: "search___es"
  }, {
    path: "/es/support",
    component: _5916702c,
    name: "support___es"
  }, {
    path: "/es/templates",
    component: _69145ed4,
    name: "templates___es"
  }, {
    path: "/es/terms",
    component: _a5438f42,
    name: "terms___es"
  }, {
    path: "/es/use-cases",
    component: _51035a18,
    name: "use-cases___es"
  }, {
    path: "/",
    component: _03607a2a,
    name: "index___en"
  }, {
    path: "/bg/blog/kategorii/:slug",
    component: _69b176f8,
    name: "blog-topics-slug___bg"
  }, {
    path: "/bg/support/kategorii/:slug",
    component: _49fe2c77,
    name: "support-topics-slug___bg"
  }, {
    path: "/es/blog/topics/:slug",
    component: _69b176f8,
    name: "blog-topics-slug___es"
  }, {
    path: "/es/support/topics/:slug",
    component: _49fe2c77,
    name: "support-topics-slug___es"
  }, {
    path: "/bg/blog/:slug",
    component: _6d4f5996,
    name: "blog-slug___bg"
  }, {
    path: "/bg/integracii/:slug",
    component: _02bd3072,
    name: "integrations-slug___bg"
  }, {
    path: "/bg/pomoshten-centar/:slug",
    component: _5c83b2bc,
    name: "support-slug___bg"
  }, {
    path: "/bg/primeri-za-polzvane/:slug",
    component: _4f4cb8d0,
    name: "use-cases-slug___bg"
  }, {
    path: "/bg/sravnenie/:slug",
    component: _008ccadc,
    name: "comparison-slug___bg"
  }, {
    path: "/bg/templeiti/:slug",
    component: _675dbd8c,
    name: "templates-slug___bg"
  }, {
    path: "/blog/topics/:slug",
    component: _69b176f8,
    name: "blog-topics-slug___en"
  }, {
    path: "/es/blog/:slug",
    component: _6d4f5996,
    name: "blog-slug___es"
  }, {
    path: "/es/casos-de-uso/:slug",
    component: _4f4cb8d0,
    name: "use-cases-slug___es"
  }, {
    path: "/es/comparar/:slug",
    component: _008ccadc,
    name: "comparison-slug___es"
  }, {
    path: "/es/integraciones/:slug",
    component: _02bd3072,
    name: "integrations-slug___es"
  }, {
    path: "/es/plantillas/:slug",
    component: _675dbd8c,
    name: "templates-slug___es"
  }, {
    path: "/es/soporte/:slug",
    component: _5c83b2bc,
    name: "support-slug___es"
  }, {
    path: "/support/topics/:slug",
    component: _49fe2c77,
    name: "support-topics-slug___en"
  }, {
    path: "/blog/:slug",
    component: _6d4f5996,
    name: "blog-slug___en"
  }, {
    path: "/comparison/:slug",
    component: _008ccadc,
    name: "comparison-slug___en"
  }, {
    path: "/integrations/:slug",
    component: _02bd3072,
    name: "integrations-slug___en"
  }, {
    path: "/support/:slug",
    component: _5c83b2bc,
    name: "support-slug___en"
  }, {
    path: "/templates/:slug",
    component: _675dbd8c,
    name: "templates-slug___en"
  }, {
    path: "/use-cases/:slug",
    component: _4f4cb8d0,
    name: "use-cases-slug___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
